export enum TaskCreatedFrom {
  DASHBOARD = 'DASHBOARD',
  OVERVIEW = 'OVERVIEW',
  GOAL = 'GOAL',
  ONE_TO_ONE = 'ONE_TO_ONE',
  CAREERS = 'CAREERS'
}
